var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7953 0.854197L5.24867 10.0675L2.71534 7.36086C2.24867 6.92086 1.51534 6.8942 0.982005 7.26753C0.462005 7.6542 0.315338 8.3342 0.635338 8.88086L3.63534 13.7609C3.92867 14.2142 4.43534 14.4942 5.00867 14.4942C5.55534 14.4942 6.07534 14.2142 6.36867 13.7609C6.84867 13.1342 16.0087 2.2142 16.0087 2.2142C17.2087 0.98753 15.7553 -0.0924696 14.7953 0.840864V0.854197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.26c9a8b10e937a50d8b19740c65bea40.svg";
export { ForwardRef as ReactComponent };